import React, { useEffect } from 'react'
import styled from '@emotion/styled';
import config from '../config';
import ImageGrid from './ImageGrid';

const AdminProductViewContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
});


const AdminProductView = ({productId}) => {
    const [images, setImages] = React.useState([]);
    const [pdp, setPdp] = React.useState([]);

    useEffect(() => {
        fetchProductInfo(productId).then(reposeData => {
            setImages(reposeData[0]);
            setPdp(reposeData[1]);
        }).catch((error) => {
            console.error(error);
        });
      }, []);

  const fetchProductInfo = async productId => {
    console.log(config.serverUrl);
    const response = await fetch(`${config.serverUrl}/products/${productId}`);
    const data = await response.json();
    if (response.status == 404) {
      throw new Error('Session not found, please double check the URL');
    } else if (response.status != 200) {
      throw new Error(`Something went wrong, please try again later, ${data.message}`);
    }

    let image = data.images;
    let pdp = data.pdp_url;
    return [image, pdp]
  };

  return (
    <AdminProductViewContainer>
        <a href={pdp} target="_blank">{pdp}</a>
        {
            images.length > 0 &&  <ImageGrid images={images} ignoreFilters={true} />
        }
        {
            images.length == 0 && <p>Loading</p>
        }
    </AdminProductViewContainer>
  )
}

export default AdminProductView